  // coffeelint: disable
angular.module('gym.form', ['gym.field', 'model']).factory('Form', [
  'Field',
  'Model',
  function(Field,
  Model) {
    var Form;
    return Form = (function() {
      class Form extends Model {
        constructor() {
          super(...arguments);
          this.fields = this.wrapCollection('fields', Field);
        }

        label() {
          return this.attributes.label;
        }

        name() {
          return this.attributes.name;
        }

        gymId() {
          return this.gym().id();
        }

        isCollection() {
          return this.attributes.collection;
        }

        toContactForm() {
          var result;
          result = this.dupe();
          result.form_id = this.attributes.id;
          result.id = this.attributes.id;
          return result;
        }

        toUserForm() {
          var result;
          result = this.dupe();
          result.form_id = this.attributes.id;
          return result;
        }

        listFields() {
          var field, i, len, ref, results;
          ref = this.fields();
          results = [];
          for (i = 0, len = ref.length; i < len; i++) {
            field = ref[i];
            if (field.show_in_list) {
              results.push(field);
            }
          }
          return results;
        }

        unarchivedFields() {
          var field, i, len, ref, results;
          ref = this.fields();
          results = [];
          for (i = 0, len = ref.length; i < len; i++) {
            field = ref[i];
            if (!field.archived) {
              results.push(field);
            }
          }
          return results;
        }

        isCustom() {
          return !this.attributes['system?'];
        }

        deletable() {
          return this.attributes['deletable'];
        }

      };

      Form.param = 'form';

      Form.prototype.gym = Form.prototype.parent;

      return Form;

    }).call(this);
  }
]);

// coffeelint: enable
